import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/courses`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/courses`, payload);
};

const find = (merchantId, id, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/courses/${id}`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/courses/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/courses/${id}`, payload);
};
const sort = (merchantId, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/courses/arrange`, payload);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	sort,
};
